import { useEffect, useState } from "react";
import { useApi } from "../../hooks";

export const EventsResults = () => {
  const { fetchEvents } = useApi();
  const [events, setEvents] = useState<any[]>([]);
  const [totalNumEvents, setTotalNumEvents] = useState<number>(0);
  useEffect(() => {
    const initialize = async () => {
      const results = await fetchEvents();
      setEvents(results.hits);
      setTotalNumEvents(results.total);
    };
    initialize();
  }, [fetchEvents]);

  return (
    <div>
      <h2>Number of Events: {totalNumEvents}</h2>
      {events.map((event) => (
        <div key={event._id}>
          <h3>{event._source.post_date}</h3>
          <h4>{event._source.post_title}</h4>
        </div>
      ))}
    </div>
  );
};
